export const defaultPeriscopeState = {
    analysisTarget: null,
    cards: []
};
